import { Controller } from "@hotwired/stimulus";
import * as bootstrap from "bootstrap";

export default class extends Controller {
  connect() {
    new bootstrap.Tooltip(this.element, {
      modifiers: {
        keepTogether: { enabled: false }
      }
    });
  }

  disconnect() {
    const tooltip = bootstrap.Tooltip.getInstance(this.element);
    tooltip.dispose();
  }
}
